import { render } from "./createPublicPersonStepOne.vue?vue&type=template&id=0f8e9b38&scoped=true"
import script from "./createPublicPersonStepOne.vue?vue&type=script&lang=js"
export * from "./createPublicPersonStepOne.vue?vue&type=script&lang=js"

import "./createPublicPersonStepOne.vue?vue&type=style&index=0&id=0f8e9b38&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8e9b38"]])

export default __exports__